import api from './client'

// La clave del comando lleva ":" (ej. presea:auditar-datos) → encodeURIComponent.
export const automataApi = {
  listar:   ()       => api.get('/automata'),
  pausar:   (clave)  => api.post(`/automata/${encodeURIComponent(clave)}/pausar`),
  reanudar: (clave)  => api.post(`/automata/${encodeURIComponent(clave)}/reanudar`),
}
